import { IAxiosResponseData } from '@/store';
import { axios } from '@/nmb/request';
const api = `api/Mysoft.Calendar.Common.AppServices.WeeklyAppService/`;

//请求历史周报数据
export const GetHistoryWeekly = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetHistoryWeekly`, params);

//获取周报
export const GetWeekly = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetWeekly`, params);

//GetWeeklyList
export const GetWeeklyList = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetWeeklyList`, params);

//保存周报
export const SaveWeekly = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}SaveWeekly`, params);

//从日历同步全部
export const ResetWeekly = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}ResetWeekly`, params);

// 从周报反填下周工作计划到日历
export const BackfillNextWeekWorkPlan = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}BackfillNextWeekWorkPlan`, params);

//发送 SendWeekly
export const SendWeekly = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}SendWeekly`, params);

// 上传图片
export const uploadImages = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}UploadImages`, params);

// 周报发送情况统计
const staticApi = `api/Mysoft.Calendar.Common.AppServices.WeeklyStatisticsAppService/`;
export const GetWeeklyStatisticsData = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${staticApi}GetWeeklyStatisticsData`, params);
